import React, { useCallback, useState, useMemo, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  Icon,
  P,
  If,
  Stack,
  Menu,
  Clickable,
} from '@fashionnovateam/nova-ui-toolkit';
import cn from 'classnames';
import MessageModal from '../Admin/MessageModal';
import { NavigationFooterProps } from './Props';
import { ContactDrawer } from './ContactDrawer';
import { useNavigation } from '../../Lib/Hooks/navigation';
import { MaybeTooltip } from './NavigationLinks';
import { FeatureFlagsContext } from '../../Lib/Contexts/FeatureFlagsContext';

export function NavigationBarFooter(props: NavigationFooterProps) {
  const history = useHistory();
  const { isCollapsed } = useNavigation();
  const { pathname } = useLocation();
  const { flags } = useContext(FeatureFlagsContext);
  const { user, openUserManual } = props;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [messageModalOpen, setMessageModalOpen] = useState(false);

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const toggleMessageModal = useCallback(
    () => setMessageModalOpen((prev) => !prev),
    [],
  );

  const handleHelpCenterClick = () => {
    history.push(`/users/${user.id}/help-center`);
  };

  const handleAnnouncementLogClick = () => {
    history.push(`/users/${user.id}/announcement-logs`);
  };
  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen((prev) => !prev);
  }, []);

  const getText = (text: string) => (isCollapsed ? '' : text);

  const isPathActive = (path: string) =>
    pathname === path || pathname.startsWith(path);

  const isHelpCenterActive = isPathActive(`/users/${user.id}/help-center`);
  const isAnnouncementLogsActive = isPathActive(
    `/users/${user.id}/announcement-logs`,
  );

  return (
    <Stack direction="col" className="pt-4 border-t border-neutral-300">
      <Menu.Group>
        <If
          condition={
            user.role === 'VENDOR' ||
            user.role === 'VENDOR_STAFF' ||
            user.role === 'VENDOR_OPERATIONS'
          }
        >
          {flags?.help_center?.enabled ? (
            <>
              <Clickable className="w-full" onClick={handleHelpCenterClick}>
                <MaybeTooltip condition={isCollapsed} content="Help Center">
                  <Menu.Item
                    icon="question/question-mark-circle"
                    isActive={isHelpCenterActive}
                  >
                    {!isCollapsed && <span>{getText('Help Center')}</span>}
                  </Menu.Item>
                </MaybeTooltip>
              </Clickable>
              <Clickable
                className="w-full"
                onClick={handleAnnouncementLogClick}
              >
                <MaybeTooltip
                  condition={isCollapsed}
                  content="Announcement Log"
                >
                  <Menu.Item
                    icon="rocket-ship"
                    isActive={isAnnouncementLogsActive}
                  >
                    {!isCollapsed && <span>{getText('Updates')}</span>}
                  </Menu.Item>
                </MaybeTooltip>
              </Clickable>
            </>
          ) : (
            <Clickable className="w-full" onClick={toggleDrawer}>
              <MaybeTooltip condition={isCollapsed} content="Contact">
                <Menu.Item icon="send-plane/send-plane-slant">
                  {!isCollapsed && (
                    <span className="truncate">{getText('Contact')}</span>
                  )}
                </Menu.Item>
              </MaybeTooltip>
            </Clickable>
          )}
        </If>
        <If condition={user.role === 'INFLUENCER'}>
          <Clickable className="w-full" onClick={openUserManual}>
            <MaybeTooltip condition={isCollapsed} content="Help">
              <Menu.Item icon="question/question-mark-circle">
                {!isCollapsed && (
                  <span className="truncate">{getText('Help')}</span>
                )}
              </Menu.Item>
            </MaybeTooltip>
          </Clickable>
          <Clickable className="w-full" onClick={toggleDrawer}>
            <MaybeTooltip condition={isCollapsed} content="Contact">
              <Menu.Item icon="send-plane/send-plane-slant">
                {!isCollapsed && (
                  <span className="truncate">{getText('Contact')}</span>
                )}
              </Menu.Item>
            </MaybeTooltip>
          </Clickable>
        </If>
        <If condition={user.role === 'ADMIN'}>
          <Clickable onClick={toggleMessageModal} className="w-full">
            <MaybeTooltip condition={isCollapsed} content="Set Portal Message">
              <Menu.Item icon="send-plane/send-plane-slant">
                {!isCollapsed && (
                  <span className="truncate">
                    {getText('Set Portal Message')}
                  </span>
                )}
              </Menu.Item>
            </MaybeTooltip>
          </Clickable>
          <MessageModal open={messageModalOpen} onClose={toggleMessageModal} />
        </If>
      </Menu.Group>
      <P
        color="disabled"
        size="2xs"
        className={cn(
          'flex flex-row items-center gap-2 p-6 pt-4 truncate',
          isCollapsed && 'justify-center text-center',
        )}
      >
        {!isCollapsed && <Icon name="fn-logo" />}© {currentYear}
      </P>
      <ContactDrawer user={user} isOpen={isDrawerOpen} onClose={toggleDrawer} />
    </Stack>
  );
}
